import { css as a, styled as i } from "./styled2.mjs";
import { Link as o, linkClasses as n } from "@mui/material";
const p = a`
	&:hover {
		text-decoration: none;
	}
`, l = a`
	border-width: 1px;
	border-style: solid;
	border-color: ${({ $disabled: t, $active: e, theme: r }) => t ? r.palette.other.divider : e ? r.palette.primary.main : r.palette.other.divider};

	&:hover {
		border-color: ${({ $disabled: t, $active: e, theme: r }) => t ? r.palette.other.divider : e ? r.palette.primary.main : r.palette.primary.main30};
	}
`, d = a`
	background-color: ${({ $disabled: t, $active: e, theme: r }) => t ? r.palette.grey[200] : e ? r.palette.primary.main08 : r.palette.grey[50]};

	&:hover {
		box-shadow: ${({ $disabled: t, $active: e, theme: r }) => !t && !e ? r.shadows[0] : "none"};
	}
`, y = i(o)`
	padding: 4px 8px;
	display: flex;
	align-items: center;
	gap: 4px;
	border-radius: 4px;
	text-decoration: none;

	color: ${({ $disabled: t, $active: e, theme: r }) => t ? e ? r.palette.primary.main30 : r.palette.text.disabled : e ? r.palette.primary.main : r.palette.text.primary};

	&:hover {
		color: ${({ $disabled: t, $active: e, theme: r }) => t ? e ? r.palette.primary.main30 : r.palette.text.disabled : e ? r.palette.primary.dark : r.palette.primary.main};

		&.${n.root} {
			text-decoration: ${({ $disabled: t, $variant: e }) => t || e !== "plain" ? "none" : "underline"};
		}

		svg {
			color: ${({ $disabled: t, $active: e, theme: r }) => e ? r.palette.primary.main : t ? r.palette.text.disabled : r.palette.primary.main};
		}
	}

	${({ $variant: t }) => t === "plain" && p};
	${({ $variant: t }) => t === "outline" && l};
	${({ $variant: t }) => t === "filled" && d};

	svg {
		width: ${({ theme: t }) => t.spacing(2.5)};
		height: ${({ theme: t }) => t.spacing(2.5)};

		color: ${({ $disabled: t, $active: e, theme: r }) => e ? r.palette.primary.main : t ? r.palette.text.disabled : r.palette.action.active};
	}

	cursor: ${({ $disabled: t }) => t ? "default" : "pointer"};
`;
export {
  y as LinkWrapper
};
//# sourceMappingURL=styles58.mjs.map
